import { render, staticRenderFns } from "./PictureTable.vue?vue&type=template&id=4b556873&scoped=true&lang=pug"
import script from "./PictureTable.vue?vue&type=script&lang=ts"
export * from "./PictureTable.vue?vue&type=script&lang=ts"
import style0 from "./PictureTable.vue?vue&type=style&index=0&id=4b556873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b556873",
  null
  
)

export default component.exports